import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/store";
import Loader from "../Loader";
import {getGame} from "../../app/slices/game";
import {useParams} from "react-router-dom";
import GameSession from "./GameSession";
import {startGame} from "../../app/slices/game";
import GameStart from "./GameStart";
import GameTopBar from "./GameTopBar";
import toast from "react-hot-toast";
import {translations} from "../../translations";
import GameError from "./GameError";

export const TRANSITION_DURATION = 400; // ms

const Game = () => {
    const dispatch = useAppDispatch();
    const {loaded, error, data, gameStarted, language, gameTheme} = useAppSelector((state) => state.game);
    const {session_data} = useAppSelector((state) => state.gameSession);
    const {slug} = useParams();

    const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
    const [logo, setLogo] = useState<string | null>(null);

    const LANG = translations[language];

    useEffect(() => {
        // NOTE: on React.StrictMode, this useEffect is called twice on dev mode
        if (loaded) return;
        dispatch(getGame(slug));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded, slug]);

    useEffect(() => {
        // Set the document title
        if (data?.name) {
            document.title = 'Scope - ' + data.name;
        }
    }, [data?.name]);

    useEffect(() => {
        if (gameTheme && gameTheme.background_image) {
            const img = new Image();
            img.src = gameTheme.background_image;
            img.onload = () => {
                setBackgroundImage(gameTheme.background_image);
            };
        }
        if (gameTheme && gameTheme.logo) {
            const img = new Image();
            img.src = gameTheme.logo;
            img.onload = () => {
                setLogo(gameTheme.logo);
            };
        }
        if(gameTheme && gameTheme.colors){
            const root = document.documentElement;
            const colors = gameTheme.colors;
            if(colors){
                Object.entries(colors).forEach(([key, value]) => {
                    const cssVar = `--${key.replace(/_/g, '-')}`;
                    root.style.setProperty(cssVar, value as string);
               });
            }
        }
    }, [gameTheme]);

    // handle start game is a form submit
    const handleStartGame = () => {
        const formFields = data?.form;
        if (formFields) {
            const allFieldsFilled = formFields.every((field) => !field.required || (field.required && field.value !== ''));
            if (!allFieldsFilled) {
                toast.error(LANG.fill_all_fields, {position: 'top-right',});
            } else {
                dispatch(startGame());
            }
        }
    }

    let elem = <Loader/>;

    if(error){
        elem = <GameError error={error} />
    }
    else if (loaded && data) {
        if (gameStarted) {
            elem = <GameSession game_id={data.id} lang={language}/>;
        } else {
            elem = <GameStart handleStart={handleStartGame} gameData={data} slug={slug} lang={language}/>;
        }
    }

    let gameThemeContainerClass = 'game-theme-container';
    if (!gameStarted || session_data?.end) {
        gameThemeContainerClass += ' show-top-bar';
    }

    const backgroundStyle = backgroundImage ? {backgroundImage: `url(${backgroundImage})`} : undefined;

    return (
        <>
            <div className="game-bg" style={backgroundStyle}></div>
            <div className={gameThemeContainerClass}>
                <GameTopBar logo={logo}/>
                <div className='game-card-container'>
                    {elem}
                </div>
            </div>
        </>
    );
}

export default Game;